import { PretensionsI } from '../interfaces/pretensions.interface'
import { PretensionsService } from '../services/pretensions.service'
import {
    PretensionsAttachDocumentResponseT,
    PretensionsDownloadPretensionResponseT,
    PretensionsDownloadDocumentResponseT,
    PretensionsGetPretensionResponseT,
    PretensionsGetListResponseT,
    PretensionsGetParamsT,
    PretensionsGetStatusesResponseT,
    PretensionsGetTypesResponseT,
    PretensionsShowPretensionResponseT,
    PretensionsShowDocumentResponseT,
    CompensationsGetParamsT,
    PretensionChangeStatusT,
    PretensionShortT,
    QualityControlCommentT,
    PretensionsDownloadPretensionPayloadT,
    SBCommentT,
    GetGuiltySidesResponse,
} from '../types/pretensions.types'

const pretensionsService = new PretensionsService()

class PretensionsRealisation implements PretensionsI {
    deletePretension(pretension_id: number): Promise<void> {
        return pretensionsService.deletePretension(pretension_id)
    }

    deleteFile(id: number): Promise<void> {
        return pretensionsService.deleteFile(id)
    }

    getList(params: PretensionsGetParamsT): Promise<PretensionsGetListResponseT> {
        return pretensionsService.getList(params)
    }

    getPretension(pretension_id: number): Promise<PretensionsGetPretensionResponseT> {
        return pretensionsService.getPretension(pretension_id)
    }

    createPretension(form_data: FormData): Promise<void> {
        return pretensionsService.createPretension(form_data)
    }

    exportExcel(
        payload: PretensionsDownloadPretensionPayloadT
    ): Promise<PretensionsDownloadPretensionResponseT> {
        return pretensionsService.exportExcel(payload)
    }

    saveAgreedData(params: CompensationsGetParamsT): Promise<void> {
        return pretensionsService.saveAgreedData(params)
    }

    changeStatus(status_params: PretensionChangeStatusT): Promise<void> {
        return pretensionsService.changeStatus(status_params)
    }

    saveLegalDepartmentComment(id: number, payload: FormData): Promise<void> {
        return pretensionsService.saveLegalDepartmentComment(id, payload)
    }

    updatePretensionInfo(params: PretensionShortT): Promise<void> {
        return pretensionsService.updatePretensionInfo(params)
    }

    addQualityControlComment(comment_params: QualityControlCommentT): Promise<void> {
        return pretensionsService.addQualityControlComment(comment_params)
    }

    addSBComment(comment_params: SBCommentT): Promise<void> {
        return pretensionsService.addSBComment(comment_params)
    }

    addEmployeeFiles(files_params: FormData): Promise<void> {
        return pretensionsService.addEmployeeFiles(files_params)
    }

    attachDocument(params: FormData): Promise<PretensionsAttachDocumentResponseT> {
        return pretensionsService.attachDocument(params)
    }

    downloadPretension(pretension_id: number): Promise<PretensionsDownloadPretensionResponseT> {
        return pretensionsService.downloadPretension(pretension_id)
    }

    showPretension(pretension_id: number): Promise<PretensionsShowPretensionResponseT> {
        return pretensionsService.showPretension(pretension_id)
    }

    downloadDocument(document_id: number): Promise<PretensionsDownloadDocumentResponseT> {
        return pretensionsService.downloadDocument(document_id)
    }

    showDocument(document_id: number): Promise<PretensionsShowDocumentResponseT> {
        return pretensionsService.showDocument(document_id)
    }

    getTypes(page: number): Promise<PretensionsGetTypesResponseT> {
        return pretensionsService.getTypes(page)
    }

    getGuiltySides(): Promise<GetGuiltySidesResponse> {
        return pretensionsService.getGuiltySides()
    }

    getStatuses(page: number): Promise<PretensionsGetStatusesResponseT> {
        return pretensionsService.getStatuses(page)
    }

    getCompensations(page: number): Promise<PretensionsGetTypesResponseT> {
        return pretensionsService.getCompensations(page)
    }

    getCulprits(page: number): Promise<PretensionsGetTypesResponseT> {
        return pretensionsService.getCulprits(page)
    }
}

export const pretensions = new PretensionsRealisation()
